module.exports = __webpack_public_path__ + "img/39.601da9fc.webp";